import useCreate from "../useCreate";
import toast from "react-hot-toast";

const useCreateVariant = ({ reset }) => {
  // Use your generic create hook
  const { setDataToServer } = useCreate({
    url: "product/variant/create",
    refreshUrl: "product/variant/list",
    onSuccess: () => {
      toast.success("Variant created successfully", {
        position: "top-right",
        duration: 3000,
      });
      reset?.();
    },
  });

  // Call this to create a variant
  const handleSubmit = (data) => {
    setDataToServer.mutate(data);
  };

  return { handleSubmit };
};

export default useCreateVariant;
